"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cadence = void 0;
exports.DayOfMonth = DayOfMonth;
exports.CalcMonthly = CalcMonthly;
exports.CalcWeekly = CalcWeekly;
exports.CalcBiWeekly = CalcBiWeekly;
exports.CalcQuarterly = CalcQuarterly;
const date_1 = require("./date");
var Cadence;
(function (Cadence) {
    Cadence["DAILY"] = "DAILY";
    Cadence["WEEKLY"] = "WEEKLY";
    Cadence["BI_WEEKLY"] = "BI_WEEKLY";
    Cadence["MONTHLY"] = "MONTHLY";
    Cadence["QUARTERLY"] = "QUARTERLY";
    Cadence["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    Cadence["ANNUALLY"] = "ANNUALLY";
    Cadence["MATURITY"] = "MATURITY";
})(Cadence || (exports.Cadence = Cadence = {}));
class MonthIter {
    constructor(month, year) {
        this.month = month;
        this.year = year;
    }
    incr() {
        this.month++;
        if (this.month >= 13) {
            this.month = 1;
            this.year++;
        }
    }
    eq(other) {
        return this.month === other.month && this.year === other.year;
    }
    neq(other) {
        return !this.eq(other);
    }
    lt(other) {
        if (this.year < other.year) {
            return true;
        }
        if (this.year === other.year) {
            return this.month < other.month;
        }
        return false;
    }
    lte(other) {
        return this.lt(other) || this.eq(other);
    }
}
function DayOfMonth(month, year, n, day_of_week) {
    // Find first day-of-week this month
    let date = new date_1.Date(year, month, 1);
    let curr = 0;
    while (date.dayOfWeek() !== day_of_week) {
        date = date.increment();
    }
    while (curr < n) {
        date = date.addDay(7);
        curr++;
    }
    return date;
}
/**
 * Calculate a monthly date that's the n-th day of week each month.
 */
function CalcMonthly(from_date, to_date, day_of_week, n) {
    const curr = new MonthIter(from_date.month, from_date.year);
    const end = new MonthIter(to_date.month, to_date.year);
    const result = [];
    while (curr.lte(end)) {
        const date_of_month = DayOfMonth(curr.month, curr.year, n, day_of_week);
        if (date_of_month.gte(from_date) && date_of_month.lte(to_date)) {
            result.push(date_of_month);
        }
        curr.incr();
    }
    return result;
}
function CalcWeekly(from_date, to_date, day_of_week) {
    const result = [];
    let curr = from_date.copy();
    while (curr.dayOfWeek() !== day_of_week) {
        curr = curr.increment();
    }
    while (curr.lte(to_date)) {
        result.push(curr);
        curr = curr.addDay(7);
    }
    return result;
}
function CalcBiWeekly(from_date, to_date, day_of_week) {
    const result = [];
    let curr = from_date.copy();
    while (curr.dayOfWeek() !== day_of_week) {
        curr = curr.increment();
    }
    while (curr.lte(to_date)) {
        result.push(curr);
        curr = curr.addDay(14);
    }
    return result;
}
function CalcQuarterly(from_date, to_date) {
    let curr = from_date.addMonth(3);
    const result = [];
    while (curr.lte(to_date)) {
        result.push(curr);
        curr = curr.addMonth(3);
    }
    return result;
}
